export default __webpack_public_path__ + "static/media/lock.965ce209.png";